import {GetSeferData} from "SeferPetach/GetData";

export async function getQuestionTypes() {
    var payload = await GetSeferData("auxf2", {});
    return (payload);
}
export async function getOptionLists() {
    var args = {STATUS_ID: 1};
    var payload = await GetSeferData("olf1", args);
    return (payload);
}
export async function getQuestionLists(obj) {
    var args = {
        QUESTION_TYPES:     obj.QUESTION_TYPES.join(','),
        QUESTION_STATUS:    obj.QUESTION_STATUS.join(','),
        REQ_PT:             obj.REQ_PT,
        REQ_EN:             obj.REQ_EN,
        REQ_ES:             obj.REQ_ES,
        DT_INIT:            obj.DT_INIT,
        DT_FN:              obj.DT_FN
    };
    var payload = await GetSeferData("qf1", args);
    return (payload);
}
export async function getQuestionByID(question_id){
    var args = {
        'QUESTION_ID': question_id
    };
    var payload = await GetSeferData("qf2", args);
    return (payload);
}
export async function updateQuestion(obj){
    var args = obj;
    var payload = await GetSeferData("qf3", args);
    return (payload);
}
export async function deleteQuestion(question_id){
    var args = {
        'QUESTION_ID': question_id
    };
    var payload = await GetSeferData("qf4", args);
    return (payload);
}
export async function getQuestionUsers(question_id){
    var payload = await GetSeferData("qf5", {'QUESTION_ID': question_id});
    return (payload);
}
export async function insertQuestionUser(question_id, user_id){
    var payload = await GetSeferData("qf6", {'QUESTION_ID': question_id, 'USER_ID': user_id});
    return (payload);
}
export async function removeQuestionUser(question_id, user_id){
    var payload = await GetSeferData("qf7", {'QUESTION_ID': question_id, 'USER_ID': user_id});
    return (payload);
}